// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circle-background{
    fill: none;
    stroke: #ddd;
    border: 1px solid red;
}
.circle-progress{
    fill: none;
    /* stroke: red; */
    /* stroke-linecap: round;
    stroke-linejoin: round;    */
    
}
.circle-text{
    font-size: 14px;
    font-weight: bold;
}
.circle-text-label{
    font-size: 10px;
    color: rgb(182, 178, 178);
}`, "",{"version":3,"sources":["webpack://./src/components/CircleProgressBar/CircleProgress.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB;gCAC4B;;AAEhC;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B","sourcesContent":[".circle-background{\r\n    fill: none;\r\n    stroke: #ddd;\r\n    border: 1px solid red;\r\n}\r\n.circle-progress{\r\n    fill: none;\r\n    /* stroke: red; */\r\n    /* stroke-linecap: round;\r\n    stroke-linejoin: round;    */\r\n    \r\n}\r\n.circle-text{\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n}\r\n.circle-text-label{\r\n    font-size: 10px;\r\n    color: rgb(182, 178, 178);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
